import { loanInfoCardsWrapperBaseStyles } from '@sharedCR/loanSummary/LoanInfoCards';

export const pageBlockClasses = {
  wrapper: '!p-16 sm:!p-24',
};

export const summaryWrapperStyles = {
  ...loanInfoCardsWrapperBaseStyles,
  gridTemplateColumns: {
    xs: '1fr',
    md: 'repeat(4, 1fr)',
  },
};

export const summaryCardStyles = {
  padding: '4px 8px',
};
